import { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Form, FormGroup, Label, Input, Button } from "reactstrap";
import { init, sendForm } from "emailjs-com";
import translate from "../Translation/i18nProvider/translate";
init("user_XTHap82COBF7i6IaWoiGK");

const ContactForm = () => {
  const { register, handleSubmit, watch, errors, control } = useForm({
    mode: "onBlur",
  });
  const [contactNumber, setContactNumber] = useState("000000");
  const generateContactNumber = () => {
    const numStr = "000000" + ((Math.random() * 1000000) | 0);
    setContactNumber(numStr.substring(numStr.length - 6));
  };
  const [statusMessage, setStatusMessage] = useState("Message");

  const onSubmit = (data, e) => {
    e.preventDefault();
    const form = document.querySelector("contact-form");
    const statusMessage = document.querySelector(".status-message");
    generateContactNumber();

    sendForm("service_w0fkh0s", "template_6sdbebc", "contact-form").then(
      function (response) {
        console.log("SUCCESS!", response.status, response.text);
        e.target.reset();
        setStatusMessage(translate("contact_form_message_sent"));
        statusMessage.className = "status-message success";
        setTimeout(() => {
          statusMessage.className = "status-message";
        }, 5000);
      },
      function (error) {
        console.log("FAILED...", error);
        setStatusMessage(translate("contact_form_message_sent_Failed"));
        statusMessage.className = "status-message failure";
        setTimeout(() => {
          statusMessage.className = "status-message";
        }, 5000);
      }
    );
  };

  const handleError = (errors) => {
    console.log(errors);
  };

  const registerOptions = {
    name: {
      required: translate("contact_form_name_field_required"),
      maxLength: {
        value: 45,
        message: translate("contact_form_name_maxLength"),
      },
    },
    email: {
      required: translate("contact_form_email_required"),
      pattern: {
        value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: translate("contact_form_email_notvalid"),
      },
      maxLength: {
        value: 45,
        message: translate("contact_form_email_notvalid"),
      },
    },
    message: {
      required: translate("contact_form_message_required"),
      maxLength: {
        value: 2000,
        message: translate("contact_form_message_maxLength"),
      },
    },
  };

  return (
    <div className="container">
      <h1 className="contactForm__title">{translate("contact_form_title")}</h1>
      <p className="status-message">{statusMessage}</p>
      <Form
        className="contact-form"
        id="contact-form"
        onSubmit={handleSubmit(onSubmit, handleError)}
      >
        <input type="hidden" name="contact_number" value={contactNumber} />

        <FormGroup>
          <Label className="contactForm__name">
            {translate("contact_form_name")}{" "}
            <small className="text-danger">
              {errors.name && errors.name.message}
            </small>
          </Label>
          <Input
            type="text"
            name="name"
            autoComplete="off"
            innerRef={register(registerOptions.name)}
          />
        </FormGroup>

        <FormGroup>
          <Label className="contactForm__name">
            {translate("contact_form_email")}{" "}
            <small className="text-danger">
              {errors.email && errors.email.message}
            </small>
          </Label>
          <Input
            className="contactForm__name"
            type="email"
            name="email"
            autoComplete="off"
            innerRef={register(registerOptions.email)}
          />
        </FormGroup>

        <FormGroup>
          <Label className="contactForm__name">
            {translate("contact_form_message")}{" "}
            <small className="text-danger">
              {errors.message && errors.message.message}
            </small>
          </Label>
          <Input
            name="message"
            type="textarea"
            innerRef={register(registerOptions.message)}
          />
        </FormGroup>

        <button className="button__form" type="submit" value="Send">
          {translate("contact_form_send")}
        </button>
      </Form>
    </div>
  );
};

export default ContactForm;
